import { Entity } from 'engine/Entity';
import { emptyV2 } from 'engine/lib/V2';
import { create } from 'engine/lib/create';
import { Waterable } from 'game/behaviors/Waterable';

export class WaterSource extends Entity {
  createFacets() {
    return [
      create(Waterable, {
        maxDistance: 80,
        offset: () => emptyV2,
        amountNeeded: () => 0,
        water: () => false,
        isWaterSource: true,
      }),
    ];
  }
}
